<dxc-button
  [class.width-from-parent]="widthFromParent() == true"
  [ngClass]="className()"
  label="{{ label() | translate }}"
  (onClick)="onButtonClick()"
  (mousedown)="mouseDown($event)"
  [disabled]="disabled()"
  [size]="size()"
  [margin]="margin()"
  [iconPosition]="iconPosition()"
  [attr.mode]="mode()"
  [type]="type()"
  >
  @if (iconSrc != '') {
    <dxc-button-icon>
      <img src="{{ iconSrc }}" alt="" />
    </dxc-button-icon>
  }
</dxc-button>
